export function scaleImage(file, maxSize, mimeType) {
  mimeType = mimeType || 'image/jpeg'

  return new Promise(function(resolve) {
    var reader = new FileReader()
    reader.onload = function (readerEvent) {
      let image = new Image()
      image.crossOrigin = "Anonymous"

      image.onload = function(){
        let canvas = document.createElement('canvas')
        let { width, height } = getSize(image.width, image.height, maxSize)

        if (image.width > width || image.height > height) {
          canvas.width = width
          canvas.height = height

          canvas.getContext('2d').drawImage(image, 0, 0, width, height)
          let dataUrl = canvas.toDataURL(mimeType)
          let blob = dataURLToBlob(dataUrl)

          // A Blob() is almost a File()
          // it's just missing the two properties below which we will add
          blob.lastModifiedDate = file.lastModifiedDate
          blob.name = file.name

          resolve(blob)
        } else {
          resolve(file)
        }
      }
      image.src = readerEvent.target.result
    }
    reader.readAsDataURL(file)
  })
}

export function scaleImageToDataUrl(url, maxSize, mimeType){
  mimeType = mimeType || 'image/jpeg'

  return new Promise(function(resolve) {
    let image = new Image()
    image.crossOrigin = "Anonymous"

    image.onload = function() {
      let canvas = document.createElement('canvas')
      let { width, height } = getSize(image.width, image.height, maxSize)

      if (image.width > width || image.height > height) {
        canvas.width = width
        canvas.height = height

        canvas.getContext('2d').drawImage(image, 0, 0, width, height)
        let dataUrl = canvas.toDataURL(mimeType)
        resolve(dataUrl)
      } else {
        resolve(url)
      }
    }
    image.src = url
  })
}

/* Utility function to get new size */
function getSize (w, h, maxSize) {
  if (w > h) {
    if (w > maxSize) {
      h *= maxSize / w
      w = maxSize
    }
  } else {
    if (h > maxSize) {
      w *= maxSize / h
      h = maxSize
    }
  }
  return {
    width: Math.round(w),
    height: Math.round(h)
  }
}

/* Utility function to convert a canvas to a BLOB */
function dataURLToBlob (dataURL) {
  let BASE64_MARKER = 'base64,'
  if (dataURL.indexOf(BASE64_MARKER) == -1) {
    let parts = dataURL.split(',')
    let contentType = parts[0].split(':')[1]
    let raw = parts[1]

    return new Blob([raw], {type: contentType})
  }

  let parts = dataURL.split(BASE64_MARKER)
  let contentType = parts[0].split(':')[1]
  let raw = atob(parts[1])
  let rawLength = raw.length

  let uInt8Array = new Uint8Array(rawLength)

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i)
  }

  return new Blob([uInt8Array], {type: contentType})
}
